import {Action} from "@dp-instant/core";
import {UIEvents} from "@dp-instant/ui";
import {log} from "@dp-instant/utils";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {IWinPopupProps} from "@game/ui/interface/IWinPopupProps";
import {PopupType} from "@game/ui/PopupType";
import {inject, injectable} from "inversify";

type ShowWinPopupActionPayload = {
    id: PopupType.WIN_LEVEL | PopupType.WIN_STAGE;
    props?: IWinPopupProps;
};

@injectable()
export class ShowWinPopupAction extends Action<ShowWinPopupActionPayload> {
    @inject(TypesGame.model)
    private readonly model: GameModel;

    async execute(payload: ShowWinPopupActionPayload): Promise<any> {
        const collected = await new Promise<boolean>(onContinue => {
            const props: IWinPopupProps = {
                coins: this.model.meta.getReward(),
                scoreStage: this.model.currentContinent?.getStageScore() || 0,
                onContinue,
                showRewardAd: this.model.offerX3(),
                ...payload.props
            };
            this.dispatch(UIEvents.POPUP, {id: payload.id, props});
        });
        log.debug("win reward collected", collected);
    }
}
